import BehaviorAction from './behavior_action';

export default class BehaviorScriptAction extends BehaviorAction {
	_script;

	constructor(props = {}) {
		super(props);
	}

	get script() {
		return this._script;
	}

	set script(value) {
		this._script = value;
	}
}
